import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { IMarkets } from 'core/classes/models/IMarkets'
import { MarketApi } from 'core/classes/services/api/MarketApi'

const allMarkets = MarketApi.fetchMarkets().items
export const useMarketsAllowedForUser = () => {
  /** -------------------- Variables ----------------------- */
  const user = useSelector(selectUser)

  const allowedMarkets = useMemo<IMarkets[]>(() => {
    return allMarkets.filter((market) =>
      user.geoMarkets.some((allowedMarket) => market.Market === allowedMarket)
    ) as IMarkets[]
  }, [user.geoMarkets])

  const isFullAccess = useMemo(() => {
    const userGeoMarkets = structuredClone(user.geoMarkets).sort()
    const allGeoMarkets = allMarkets.map((it) => it.Market).sort()
    return JSON.stringify(allGeoMarkets) === JSON.stringify(userGeoMarkets)
  }, [user.geoMarkets])

  return {
    allowedMarkets,
    isFullAccess,
  }
}
